import { ReactComponent as Cricket } from '../../assets/images/sidebar/cricket.svg';
import { ReactComponent as Football } from '../../assets/images/sidebar/football.svg';
import { ReactComponent as Tennis } from '../../assets/images/sidebar/tennis.svg';
import { ReactComponent as Binary } from '../../assets/images/sidebar/binary.svg';
import { ReactComponent as Politics } from '../../assets/images/sidebar/politics.svg';
import { ReactComponent as Basketball } from '../../assets/images/sidebar/basketball.svg';
import { ReactComponent as Horseracing } from '../../assets/images/sidebar/Horse.svg';
import { ReactComponent as Baseball } from '../../assets/images/sidebar/baseball.svg';
import { ReactComponent as GreyHound } from '../../assets/images/sidebar/Greyhound.svg';
import { ReactComponent as Darts } from '../../assets/images/sidebar/darts.svg';
import { ReactComponent as Futsal } from '../../assets/images/sidebar/futsal.svg';
import { ReactComponent as TableTennis } from '../../assets/images/sidebar/table_tennis.svg';
import { ReactComponent as Volleyball } from '../../assets/images/sidebar/volleyball.svg';
import { ReactComponent as IceHockey } from '../../assets/images/sidebar/ice-hockey.svg';
import { ReactComponent as MultiMarkets } from '../../assets/images/sidebar/multi_markets.svg';
import { ReactComponent as Promotions } from '../../assets/images/sidebar/promotions.svg';
import { ReactComponent as Aviator } from '../../assets/images/sidebar/aviator.svg';
import { ReactComponent as home } from '../../assets/images/icons/home.svg';
import { ReactComponent as sportsbook } from '../../assets/images/icons/sports.svg';
import { ReactComponent as inplay } from '../../assets/images/icons/inplay-mob.svg';
import { ReactComponent as casino } from '../../assets/images/icons/casino.svg';
import { ReactComponent as casinoindian} from '../../assets/images/sidebar/casinonw.svg';
import { ReactComponent as casino1} from '../../assets/images/sidebar/casino1.svg';
import { ReactComponent as casino2} from '../../assets/images/sidebar/casino2.svg';
import { ReactComponent as casino3} from '../../assets/images/sidebar/casino3.svg';
import { ReactComponent as provider1} from '../../assets/images/sidebar/provider1.svg';
import { ReactComponent as provider2} from '../../assets/images/sidebar/provider2.svg';
import { ReactComponent as provider3} from '../../assets/images/sidebar/provider3.svg';
import { ReactComponent as worldcup} from '../../assets/images/sidebar/worldcup.svg';
import { ReactComponent as GameRules } from '../../assets/images/sidebar/game_rules.svg';
import { ReactComponent as AccountStatement } from '../../assets/images/sidebar/account_statement.svg';
import { ReactComponent as BonusStatement } from '../../assets/images/sidebar/bonus_statement.svg';
import { ReactComponent as MyBets } from '../../assets/images/sidebar/my_bets.svg';
import { ReactComponent as MyProfile } from '../../assets/images/icons/acc_stmt.svg';
import { ReactComponent as MyTransaction } from '../../assets/images/sidebar/my_transaction.svg';
import { ReactComponent as MyWallet } from '../../assets/images/sidebar/my_wallet.svg';
import { ReactComponent as ProfitLoss } from '../../assets/images/sidebar/profit_loss.svg';
import { ReactComponent as StakeSettings } from '../../assets/images/sidebar/stake_settings.svg';
import { ReactComponent as Deposit } from '../../assets/images/icons/upgraph.svg';
import { ReactComponent as Withdraw } from '../../assets/images/icons/my-bets.svg';
import { ReactComponent as Ravana } from '../../assets/images/sidebar/ravana.svg';
import { ReactComponent as TurnoverHistory } from '../../assets/images/sidebar/turnover_history.svg';
import { ReactComponent as AffiliateIcon } from '../../assets/images/sidebar/affiliate-program.svg';
import { ReactComponent as TermsPolicy } from '../../assets/images/sidebar/TermsPolicy.svg';
import { ReactComponent as Logout } from '../../assets/images/icons/logout.svg';

export const sideHeaderTabs = [
  {
    id: '',
    text: 'Home',
    langKey:'home',
    img: home,
    route: '/home',
    showWithoutLogin: true,
  },
 
];

export const sportsHeaderTabs = [
  {
    id: '',
    text: 'Inplay',
    langKey:'inplay',
    img: inplay,
    route: 'exchange_sports/inplay',
    showWithoutLogin: true,
  },
  {
    id: '',
    text: 'Sportsbook',
    langKey:'sports_book',
    img: sportsbook,
    route: '/premium_sports',
    showWithoutLogin: false,
  },
    {
    id: '23',
    text: 'Multi markets',
    langKey:'multimarkets',
    img: MultiMarkets,
    route: '/exchange_sports/multi-markets',
    showWithoutLogin: true,
  },
  {
    id: '28',
    text: 'IPL',
    langKey:'ipl',
    img: worldcup,
    route: '/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg=',
    showWithoutLogin: true,
  },
  {
    id: '4',
    text: 'cricket',
    langKey:'cricket',
    img: Cricket,
    route: '/exchange_sports/cricket',
    showWithoutLogin: true,
  },
  {
    id: '1',
    text: 'football',
    langKey:'football',
    img: Football,
    route: '/exchange_sports/football',
    showWithoutLogin: true,
  },
  {
    id: '2',
    text: 'tennis',
    langKey:'tennis',
    img: Tennis,
    route: '/exchange_sports/tennis',
    showWithoutLogin: true,
  }, 
];

export const casinoHeaderTabs = [
 
  {
    id: '8',
    text: 'Aviator',
    langKey:'aviator',
    img: Aviator,
    route: '/dc/gamev1.1/aviator-ODYwMDAx-c3ByaWJlX2F2aWF0b3I=-U1BSSUJF-U1BSSUJF',
    showWithoutLogin: true,
  },
  {
    id: '8',
    text: 'Lankesh',
    langKey:'lankesh',
    img: Ravana,
    route: '/dc/gamev1.1/lankesh-MTUxMDI2-TUFDODgtVlRHTE4xMDE=-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=',
    showWithoutLogin: true,
  },
  {
    id: '8',
    text: 'Live Casino',
    langKey:'live_casino',
    img: casino,
    route: '/casino',
    showWithoutLogin: true,
  },
  {
    id: '8',
    text: 'Indian Casino',
    langKey:'indian_casino',
    img: casinoindian,
    route: '/indian_casino',
    showWithoutLogin: true,
  },
  {
    id: '8',
    text: 'Royal Gaming',
    langKey:'royal_gaming',
    img: casino1,
    route: '/casino?provider=Royal%20Gaming',
    showWithoutLogin: true,
  },
  {
    id: '8',
    text: 'Mac88',
    langKey:'mac88',
    img: provider1,
    route: '/casino?provider=Mac88%20Gaming',
    showWithoutLogin: true,
  },
  {
    id: '8',
    text: 'Evolution',
    langKey:'evolution',
    img: casino2,
    route: '/casino?provider=Evolution%20Gaming',
    showWithoutLogin: true,
  },
  {
    id: '8',
    text: 'Ezugi',
    langKey:'ezugi',
    img: casino3,
    route: '/casino?provider=Ezugi',
    showWithoutLogin: true,
  },

  {
  id: '8',
  text: 'Monk88',
  langKey:'monk88',
  img: provider2,
  route: '/casino?provider=Monk88',
  showWithoutLogin: true,
},

{
  id: '8',
  text: 'Spribe',
  langKey:'spribe',
  img: provider3,
  route: '/casino?provider=Spribe',
  showWithoutLogin: true,
},
 
];

export const otherMenuTabs = [
  {
    id: 9,
    text: 'Deposit',
    langKey:'deposit',
    img: Deposit,
    route: '/transaction/deposit',
    showWithoutLogin: false,
  },
  {
    id: 10,
    text: 'Withdraw',
    langKey:'withdraw',
    img: Withdraw,
    route: '/transaction/withdraw',
    showWithoutLogin: false,
  },
  {
    id: 21,
    text: 'Referral',
    langKey:'referral',
    img: MyProfile,
    route: '/profile/referral',
    showWithoutLogin: false,
  },
];


export const securityAndLogout = [
  {
    id: 21,
    text: 'Terms & Policy',
    langKey:'terms_and_policy',
    img: GameRules,
    route: '/terms-conditions',
    showWithoutLogin: true,
  },
  { id: 22, text: 'Logout',langKey:'logout', img: Logout, route: '', showWithoutLogin: false },
];
